var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, css } from 'styled-components';
import { ColorsByAssessmentResult } from '../../constants/view';
var DEFAULT_SIZE = 10;
var DEFAULT_BORDER_RADIUS = 2;
var ScResultIndicator = styled.div.withConfig({ displayName: "ScResultIndicator", componentId: "sc-x3s0z9" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  display: inline-block;\n  ", "\n\n  ", "\n"])), function (_a) {
    var $size = _a.$size;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    min-width: ", "px;\n    height: ", "px;\n  "], ["\n    width: ", "px;\n    min-width: ", "px;\n    height: ", "px;\n  "])), $size, $size, $size);
}, function (_a) {
    var $color = _a.$color, $borderRadius = _a.$borderRadius;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    border-radius: ", "px;\n  "], ["\n    background-color: ", ";\n    border-radius: ", "px;\n  "])), $color, $borderRadius);
});
var AssessmentResultIndicator = function (_a) {
    var result = _a.result, _b = _a.borderRadius, borderRadius = _b === void 0 ? DEFAULT_BORDER_RADIUS : _b, _c = _a.size, size = _c === void 0 ? DEFAULT_SIZE : _c, children = _a.children, rest = __rest(_a, ["result", "borderRadius", "size", "children"]);
    return (_jsx(ScResultIndicator, __assign({ "$color": ColorsByAssessmentResult[result], "$borderRadius": borderRadius, "$size": size }, rest, { children: children }), void 0));
};
export { AssessmentResultIndicator };
var templateObject_1, templateObject_2, templateObject_3;
